import {useAppSelector} from '@/hooks';

export const useGetCurrentPageBackgroundType = () => {
  const currentPageId = useAppSelector((state) => {
    return state.posterEditor.currentPageId;
  });
  return useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages.pagesHashMap[currentPageId]?.background.details.type;
  });
};
